import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "hidden md:fixed md:inset-y-0 md:flex md:w-64 md:flex-col" }
const _hoisted_2 = { class: "flex flex-grow flex-col overflow-y-auto bg-app-theme-600 pt-5" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "mt-5 flex flex-1 flex-col" }
const _hoisted_5 = { class: "flex-1 space-y-1 px-2 pb-4" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Uitloggen ")
const _hoisted_7 = { class: "flex flex-shrink-0 border-t border-app-theme-300 p-4 bg-app-theme-600" }
const _hoisted_8 = {
  href: "#",
  class: "group block w-full flex-shrink-0"
}
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = { class: "ml-3" }
const _hoisted_11 = { class: "text-sm font-medium text-gray-100 group-hover:text-gray-900" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium text-gray-300 group-hover:text-gray-700" }, "Profiel bekijken", -1)
const _hoisted_13 = { class: "flex flex-1 flex-col md:pl-64" }
const _hoisted_14 = { class: "flex flex-col h-screen" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdminCockpitNavigationListItem = _resolveComponent("AdminCockpitNavigationListItem")!
  const _component_ArrowLeftOnRectangleIcon = _resolveComponent("ArrowLeftOnRectangleIcon")!
  const _component_UserCircleIcon = _resolveComponent("UserCircleIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(`flex flex-shrink-0 justify-center items-center px-4 ${_ctx.adminLogoConfig.addParentClass} bg-app-theme-100`)
        }, [
          _createElementVNode("img", {
            class: _normalizeClass(`${_ctx.adminLogoConfig.addClass}`),
            src: require(`@/assets/img/${_ctx.adminLogoConfig.filename}`),
            alt: "Logo"
          }, null, 10, _hoisted_3)
        ], 2),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("nav", _hoisted_5, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigation, (item) => {
                return _withDirectives((_openBlock(), _createElementBlock("li", {
                  key: item.name
                }, [
                  _createVNode(_component_AdminCockpitNavigationListItem, {
                    item: item,
                    onItemClicked: _ctx.onMenuItemClick
                  }, null, 8, ["item", "onItemClicked"])
                ])), [
                  [_vShow, item.condition === undefined || item.condition]
                ])
              }), 128)),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                  class: "text-gray-100 hover:bg-app-theme-500 group flex items-center px-2 py-2 text-sm font-medium rounded-md hover:cursor-pointer"
                }, [
                  _createVNode(_component_ArrowLeftOnRectangleIcon, {
                    class: "mr-3 h-6 w-6 flex-shrink-0 text-gray-300",
                    "aria-hidden": "true"
                  }),
                  _hoisted_6
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", null, [
                  _createVNode(_component_UserCircleIcon, { class: "w-9 h-9 text-app-theme-100" })
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.user.fullName), 1),
                  _hoisted_12
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("main", _hoisted_14, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
}